module.exports = __webpack_public_path__ + "img/fail.ee212327.png";